export enum ApplicationsColumns {
	id = "Id",
	type = "Type",
	org = "Org",
	name = "Name",
	status = "Status",
	evaluation = "Evaluation",
	createdAt = "Created At",
	updatedAt = "Updated At",
}

export type AllowedApplicationsColumns =
	| ApplicationsColumns.id
	| ApplicationsColumns.type
	| ApplicationsColumns.org
	| ApplicationsColumns.name
	| ApplicationsColumns.status
	| ApplicationsColumns.evaluation
	| ApplicationsColumns.createdAt
	| ApplicationsColumns.updatedAt
